import React, { useEffect, useState } from "react";

// Jds
import {
  Button,
  Container,
  DropdownMenuGroup,
  DropdownMenuItem,
  Icon,
  InputField,
  InputFieldV2,
  InputPhoneDropdown,
  Text,
} from "@jds/core";

// Mui
import { Box, Menu, MenuItem, Stack } from "@mui/material";

// Local
import JdsMenu from "../../UI/JdsMenu";
import useInput from "../../../hooks/use-input";
import {
  validateEmail,
  validateLink,
  validatePhoneNumber,
  validateTextInput,
} from "../../../util/validation";

const SocialDropdownMenuBtn = (props) => {
  return (
    <Box sx={{ "& .j-JDSButton-container": { borderRadius: "8px" } }}>
      <Button
        kind="secondary"
        label="Add social links"
        icon={"IcChevronDown"}
        fullWidth
        {...props}
      />
    </Box>
  );
};

export default function AdditionalDetailsForm(props) {
  const [socialLinkInputObj, setSocialLinkInputObj] = useState({});
  const [error, setError] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleDropdownClick = (event) => {
    setAnchorEl(event.currentTarget);


  };
  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClickDropdownClose = (val) => {
    if (socialLinkInputObj[val] === undefined) {
      setSocialLinkInputObj((pre) => {
        console.log({ ...pre, [val]: null })
        return { ...pre, [val]: null };
      });
    }

    setAnchorEl(null);
  };

  const socialInputObjRemoveHandler = (key) => {
    setSocialLinkInputObj((pre) => {
      let obj = { ...pre };
      delete obj[key];
      return obj;
    });
  };
  const socialLinkIcon = props.socialLinkIcon;


  const handleSaveCheck = () => {
    if (
      socialLinkInputObj == null ||
      Object.keys(socialLinkInputObj).length === 0
    ) {
      console.log('settings default')
      props?.setSocialMediaLinks &&
        props?.setSocialMediaLinks(socialLinkInputObj);
      return;
    }
    let isError = false;
    Object.keys(socialLinkInputObj).map((key) => {
      // if (socialLinkInputObj[key] == null || !socialLinkInputObj[key]) {
      //   return;
      // }

      const value = socialLinkInputObj[key];

      // Set error for empty fields
      if (!value) {
        setError((pre) => {
          return { ...pre, [key]: true };
        });
        isError = true;
        return; // Skip further checks for empty values
      }

      if (key == "email" && !validateEmail(socialLinkInputObj[key])) {
        setError((pre) => {
          return { ...pre, [key]: true };
        });
        isError = true;
      }
      if (key == "mobile" && !validatePhoneNumber(socialLinkInputObj[key])) {
        setError((pre) => {
          return { ...pre, [key]: true };
        });
        isError = true;
      }
      if (
        key != "mobile" &&
        key != "email" &&
        !validateLink(socialLinkInputObj[key])
      ) {
        console.log('link validation')
        setError((pre) => {
          return { ...pre, [key]: true };
        });
        isError = true;
      }
    });
    if (!isError) {
      console.log('settings new')
      props?.setSocialMediaLinks &&
        props?.setSocialMediaLinks(socialLinkInputObj);
      props?.onCancel();
      return;
    }
  };

  const socialMenu = [
    {
      icon: 'IcFacebook',
      label: 'Facebook',
      value: 'facebook'
    },
    {
      icon: 'IcInstagram',
      label: 'Instagram',
      value: 'instagram'
    },
    {
      icon: 'IcYoutube',
      label: 'Youtube',
      value: 'youtube'
    },
    {
      icon: 'IcGlobe',
      label: 'Website',
      value: 'website'
    },
    {
      icon: 'IcMail',
      label: 'Email',
      value: 'email'
    },
    {
      icon: 'IcCall',
      label: 'Mobile',
      value: 'mobile'
    }
  ]

  useEffect(() => {
    setSocialLinkInputObj(props?.socialMediaLinks || {});
  }, []);
  return (
    <>
      <Box mb={2}>
        {/* <JdsMenu
          trigger={{ component: SocialDropdownMenuBtn }}
          fullWidth
          onSelect={(val) => {
            if (socialLinkInputObj[val] === undefined) {
              setSocialLinkInputObj((pre) => {
                return { ...pre, [val]: null };
              });
            }
          }}
        >
          <DropdownMenuGroup hideBottomDivider>
            <DropdownMenuItem
              prefix={"IcFacebook"}
              label="Facebook"
              value={"facebook"}
            />
            <DropdownMenuItem
              prefix={"IcInstagram"}
              label="Instagram"
              value={"instagram"}
            />
            <DropdownMenuItem
              prefix={"IcYoutube"}
              label="Youtube"
              value={"youtube"}
            />
            <DropdownMenuItem
              prefix={"IcGlobe"}
              label="Website"
              value={"website"}
            />
            <DropdownMenuItem prefix={"IcMail"} label="Email" value={"email"} />
            <DropdownMenuItem
              prefix={"IcCall"}
              label="Mobile"
              value={"mobile"}
            />
          </DropdownMenuGroup>
        </JdsMenu> */}
        <SocialDropdownMenuBtn onClick={handleDropdownClick} />
        <Menu
          id="social-links-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleDropdownClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          sx={{ '& .MuiPaper-root': { width: '100%', maxWidth: '462px' } }}
        >
          {socialMenu.map((data, i) =>
            <MenuItem onClick={() => handleMenuClickDropdownClose(data?.value)} key={i}>
              <Container gap={8}>
                <Icon ic={data?.icon} />
                <Text text={data?.label} appearance="body-s" />
              </Container>
            </MenuItem>
          )}
        </Menu>
      </Box>
      <Stack direction="column" gap={2}>
        {socialLinkInputObj &&
          typeof socialLinkInputObj === "object" &&
          !Array.isArray(socialLinkInputObj) &&
          Object?.keys(socialLinkInputObj)?.map((key) => (
            <Box
              sx={{
                "& .j-JDSInputFieldV2-input-container": { height: "unset" },
                "& .j-JDSIcon-container": { padding: "24px", borderRadius: 0 },
                "& .j-JDSIcon-container:nth-child(1)": {
                  paddingLeft: "12px",
                  borderRight: "1px solid var(--color-primary-grey-60)",
                },
                "& .j-JDSIcon-container:nth-child(3)": {
                  paddingRight: "12px",
                  borderLeft: "1px solid var(--color-primary-grey-60)",
                },
                "& .j-JDSIcon-container:nth-child(1) .icon-atom.j-JDSIcon-icon":
                {
                  color: "var(--color-primary-60)",
                },
                "& .j-JDSIcon-container:nth-child(3) .icon-atom.j-JDSIcon-icon":
                {
                  color: "var(--color-feedback-error-50)",
                },
              }}
            >
              <InputFieldV2
                key={socialLinkIcon[key]?.icon}
                prefix={<Icon ic={socialLinkIcon[key]?.icon} />}
                suffix={<Icon ic="IcTrash" color="error" />}
                size="large"
                onSuffixClick={() => socialInputObjRemoveHandler(key)}
                placeholder={`Enter ${socialLinkIcon[key]?.type == "link" ? "URL..." : "Value..."
                  }`}
                value={socialLinkInputObj[key]}
                onChange={(e) => {
                  setSocialLinkInputObj((pre) => {
                    let obj = { ...pre };
                    obj[key] = e.target.value;
                    return obj;
                  });
                  setError((pre) => {
                    let obj = { ...pre };
                    delete obj[key];
                    return obj;
                  });
                }}
                state={error[key] ? "error" : "none"}
                stateText="Please enter valid input!"
              />
            </Box>
          ))}
      </Stack>
      <Container fullWidth gap={16} style={{ marginTop: "24px" }}>
        <Button
          label="Cancel"
          kind="secondary"
          fullWidth
          onClick={() => props?.onCancel()}
        />
        <Button
          label="Add"
          fullWidth
          onClick={() => {
            handleSaveCheck();
          }}
        />
      </Container>
    </>
  );
}
